import React, { Component, Fragment } from 'react';
import { Divider } from 'grab-ui';
import { Header } from 'semantic-grab-ui';
import BusinessMetricSectionView from 'omega-rtc/views/trident-campaigns/metrics/BusinessMetricSectionView';
import _ from 'lodash';
import { RAW_KEY } from 'omega-rtc/constants/metrics';

export class BusinessMetrics extends Component<
    {
      hasExpNode: boolean,
      countryID: number,
      rawMetricsMap: {},
      node: any,
      mamMetricsMap: {}
    }> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showMamToggle: false,
    };
  }

  onToggleChange = (val) => {
    this.setState({
      showMamToggle: val,
    });
  }

  render() {
    const { hasExpNode } = this.props;

    return (
      <Fragment>
        <Divider />
        {
          hasExpNode
          && <Fragment>
            <Header as="h3" style={{ marginTop: 8, marginBottom: 24 }}>
              Business Metrics
            </Header>
            <BusinessMetricSectionView
              countryID={this.props.countryID}
              metrics={_.get(this.props.rawMetricsMap, this.props.node.id, [])}
              metricType={RAW_KEY}
              hasExpNode={this.props.hasExpNode}
              node={this.props.node}
            />
          </Fragment>
        }
      </Fragment>
    );
  }
}
